// Texty modelu blogu — slovenské dvojče locale/cs/blogModel.js.
// Blog na SK neexistuje (0 článkov), dvojča je tu kvôli zhode tvaru.
import { plural } from '../plural.js';

export default {
  /** 1 článok / 2–4 články / 5+ článkov */
  articlesWord: (n) => plural(n, ['článok', 'články', 'článkov']),
  readMinutesSuffix: ' min čítania',
  readShortSuffix: ' min',
};
